import { makeStyles } from "@material-ui/core";

export const grid = 7;

const useCouponRankingStyle = makeStyles(
  theme => ({
    calendarIcon: {
      gridArea: "calendarIcon",
      height: "24px",
      marginRight: "10px",
      width: "24px"
    },
    cardContainer: {
      "@media (max-width:600px)": {
        gridTemplateColumns: "repeat(3, 1fr)"
      },
      alignItems: "center",
      display: "grid",
      justifyContent: "space-between",
      padding: "2px",
      position: "relative"
    },
    cardContent: {
      alignItems: "center",
      display: "grid",
      gridColumnGap: "1px",
      gridTemplateColumns: "0.5fr 1fr 1fr 1fr 2fr 0.5fr",
      height: "100%",
      justifyContent: "center",
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        gap: theme.spacing(1),
        gridTemplateColumns: "min-content 1fr minmax(auto, max-content) 1fr 1fr"
      }
    },
    cardMenuContainer: {
      border: "none",
      paddingRight: theme.spacing(2)
    },
    chip: {
      maxWidth: "150px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    claimingDates: {
      fontSize: "calc(4px + 0.4vw)",
      fontWeight: "bold"
    },
    claimingDatesText: {
      fontSize: 12,
      fontWeight: "bold"
    },
    claimingPeriod: {
      alignItems: "center",
      display: "grid",
      gridTemplateAreas: `
        "icon label"
        "icon dates"
      `,
      gridTemplateColumns: "min-content auto",
      whiteSpace: "nowrap"
    },
    claimingPeriodLabel: {
      alignItems: "left",
      display: "flex",
      gridArea: "datesLabel",
      whiteSpace: "nowrap"
    },
    couponCardMenu: {
      color: "#247CFF",
      fontSize: "medium",
      marginLeft: "10px"
    },
    couponCode: {
      backgroundColor: "#B4F3DF",
      borderRadius: "5px",
      color: "#236C63",
      display: "inline-block",
      fontSize: 16,
      fontWeight: "bold",
      margin: "0 30px 0 30px",
      overflow: "hidden",
      padding: "5px 10px",
      textAlign: "center",
      textOverflow: "ellipsis"
    },
    couponQuantity: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column"
    },
    couponStatus: {
      fontSize: 10,
      fontWeight: "bold"
    },
    couponTitle: {
      color: "#000000",
      fontSize: 16,
      fontWeight: "bold",
      textAlign: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: 8
      }
    },
    dashedPlaceholder: {
      alignItems: "center",
      backgroundColor: "#f4f8ff",
      border: "4px dashed #204AFF",
      borderRadius: "5px",
      boxSizing: "border-box",
      display: "flex",
      height: "100px",
      justifyContent: "center",
      margin: "10px 30px 5px 10px",
      padding: "0 20px 0 0"
    },
    datesQuantitySection: {
      alignItems: "center",
      display: "grid",
      gridTemplateAreas: `
      "calendarIcon datesLabel divider ticketIcon label"
      "calendarIcon dates divider ticketIcon quantity"
      `,
      gridTemplateColumns: "1fr 1fr 0.5 1fr 1fr"
    },
    dragAnchorIcon: {
      textAlign: "center"
    },
    draggableCard: {
      "&:hover, &.selected": {
        backgroundColor: "#F4F8FF",
        border: "2px solid #418CFF",
        boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
        transform: "scale(1.01)"
      },
      backgroundColor: "#FFFFFF",
      borderRadius: "5px",
      boxShadow: "0 3px 8px rgba(0, 0, 0, 0.2)",
      boxSizing: "border-box",
      display: "flex",
      height: "100px",
      justifyContent: "space-between",
      margin: "10px 30px 5px 10px",
      transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
      width: "calc(100% - 20px)"
    },
    draggableContainer: {
      flexDirection: "column"
    },
    flexFullWidth: {
      display: "flex",
      height: "100%",
      placeItems: "center",
      width: "100%"
    },
    flexGrowContainer: {
      flexGrow: 0.1
    },
    flexRow: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      margin: theme.spacing(1, 0)
    },
    footer: {
      "&:before, &:after": {
        borderBottom: "1px solid #000",
        content: '""',
        flex: 1,
        margin: "0 10px"
      },
      alignItems: "center",
      color: "#747C8C",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "30px",
      position: "relative",
      textAlign: "center"
    },
    halfWidthContainer: {
      margin: "0 30px 0 30px",
      width: "5%"
    },
    halfWidthFlexContainer: {
      display: "flex",
      margin: "auto",
      whiteSpace: "nowrap",
      width: "25%"
    },
    movedCard: {
      "&::before": {
        backgroundColor: "#418CFF",
        borderRadius: "50%",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.25)",
        content: '""',
        height: "20px",
        left: 0,
        position: "absolute",
        top: 0,
        transform: "translate(-50%, -50%)",
        width: "20px"
      },
      border: "2px solid #418CFF",
      height: "100px",
      margin: "10px 30px 5px 10px",
      position: "relative"
    },
    remainingCouponLabel: {
      alignItems: "center",
      color: "#747C8C",
      display: "flex",
      fontSize: 10,
      gridArea: "label",
      whiteSpace: "nowrap"
    },
    remainingCoupons: {
      alignItems: "center",
      display: "grid",
      gridTemplateAreas: `
        "icon label"
        "icon quantity"
      `,
      gridTemplateColumns: "min-content min-content auto",
      whiteSpace: "nowrap"
    },
    remainingQuantities: {
      fontSize: 12,
      fontWeight: "bold"
    },
    showPlaceholder: {
      display: "block"
    },
    starIcon: {
      color: "#FFDB00",
      height: "39px",
      width: "40px"
    },
    textLabel: {
      color: "#747C8C",
      fontSize: 12
    },
    ticketIcon: {
      gridArea: "ticketIcon",
      height: "24px",
      marginRight: "10px",
      width: "24px"
    },
    verticalDivider: {
      backgroundColor: "#C4C4C4",
      gridArea: "divider",
      height: "100%",
      margin: "0 12px",
      width: "1px"
    },
    verticalSpacing: {
      marginBottom: theme.spacing(5),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(5)
    }
  }),
  { name: "CouponRankingList" }
);

export default useCouponRankingStyle;

export const getItemStyle = (isDragging, draggableStyle) => ({
  border: isDragging ? "2px" : "none",
  userSelect: "none",
  ...draggableStyle
});

export const getListStyle = () => ({
  background: "none",
  padding: grid
});

export const CouponStatus = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  DRAFT: "EDITING",
  EXPIRED: "EXPIRED",
  INACTIVE: "INACTIVE",
  SCHEDULED: "SCHEDULED"
};

export const statusColors = {
  ACTIVE: "#BAC8FF",
  COMPLETED: "#C3F2E9",
  DRAFT: "#FFF0BD",
  EXPIRED: "#F8BFC1",
  INACTIVE: "#D9D9D9",
  SCHEDULED: "#BAC8FF"
};

export const fiberIconColors = {
  ACTIVE: "#5D7FFE",
  COMPLETED: "#63D6B7",
  DRAFT: "#FECE21",
  EXPIRED: "#E72531",
  INACTIVE: "#9C9C9C",
  SCHEDULED: "#5D7FFE"
};
